<template>
  <v-content>
    <v-container @keyup.enter='updatePassword' class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12" v-if="token != null">
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>Update Password</v-toolbar-title>
              </v-container>
              <v-spacer />
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-form v-model="valid" ref="form">
                  <template v-if="(Array.isArray(errors) == true ? (errors.length >0 ? true:false ): false )">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">                        
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>

                      </v-col>
                    </v-row>
                  </template>
                  <template v-else-if="errors.length >0 ? true: false">
                    <v-row>
                      <v-col cols="12" sm="12" md="12"> 

                          <v-alert
                            dense
                            outlined
                            
                            type="error"
                          >{{ errors }}</v-alert>

                      </v-col>
                    </v-row>
                  </template>


                 
                  <v-text-field
                    v-model="password"
                    :rules="passwordRules"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                  />
                  <v-text-field
                    v-model="confirmpassword"
                    label="Confirm Password"
                    :rules= "confirmpasswordRules"
                    name="confirmpassword"
                    prepend-icon="lock"
                    type="password"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="updatePassword">Update</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>

          <v-card class="elevation-12" v-else-if='token == null'>
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>Update Password</v-toolbar-title>
              </v-container>
              <v-spacer />
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-alert dense outlined  type="error">{{ 'This password reset token is invalid' }}</v-alert>
              </v-card-text>
            </v-container>
          </v-card>

        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { CHECK_TOKEN, CHECK_AUTH, FETCH_LANGUAGES, FETCH_PAGES, UPDATE_PASSWORD } from "@/store/actions.type"
import { SET_LOADING} from "@/store/mutations.type"
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "ResetPassword",
  created() {
    if(this.$route.query.token && this.$route.query.is_comp_admin){
       store.dispatch(CHECK_TOKEN, this.$route.query.token+'?is_comp_admin='+this.$route.query.is_comp_admin).then(resp =>{
         if(resp !=undefined && resp.success){
          this.email = this.$route.query.email
          this.token = this.$route.query.token
          this.$store.commit(SET_LOADING, false)

         }
         else{
           this.token = null
           this.$store.commit(SET_LOADING, false)
         }
       })

    }
    else if(this.$route.query.token){
       store.dispatch(CHECK_TOKEN, this.$route.query.token).then(resp =>{
         if(resp !=undefined && resp.success){
          this.email = this.$route.query.email
          this.is_comp_admin = this.$route.query.is_comp_admin
          this.token = this.$route.query.token
          this.$store.commit(SET_LOADING, false)

         }
         else{
           this.token = null
           this.$store.commit(SET_LOADING, false)
         }
       })

    }
  },   
  data() {
    return {
      valid: false,
      password: "",
      passwordRules: [v => !!v || "Password is required"],
      confirmpassword: "",
      confirmpasswordRules: [
      password => !!password || 'Password is required',
      confirmation => confirmation === this.password || 'Passwords must match'
      ],      
      email: null,
      is_comp_admin: null,
      token: null,
    };
  },
  methods: {
    updatePassword: function() {
      if (this.$refs.form.validate()) {
        let password = this.password
        let email = this.userTokenData.email
        let token = this.userTokenData.token
        let is_joining = this.$route.query.is_joining
        let is_comp_admin =  (this.$route.query.is_comp_admin? 1 : '' )
        var data = {}
        if(is_comp_admin){
          data = {password, email, token, is_comp_admin, is_joining}
        }
        else{
          data = {password, email, token, is_joining}
        }
        this.$store
          .dispatch(UPDATE_PASSWORD, data)
          .then(async resp =>{
            if(resp.success){
             await this.$store.dispatch(CHECK_AUTH).then( async userresp =>{
              if(userresp !== undefined && userresp.hasOwnProperty('success') && userresp.success ==true){
                 await this.$store.dispatch(FETCH_LANGUAGES, '').then(async resp =>{
                  if(resp.success){
                  this.$store
                    .dispatch(FETCH_PAGES, "?lang_ids=" + (this.curLanguage != null ? this.curLanguage.lang_id : userresp.data.user.company.language.lang_id)).then(resp => {
                      if (resp.success) {
                        this.$store.commit(SET_LOADING, false)
                        this.$router.push("/learningcenter")
                      }
                    });
                  }
                }) 
              }
             })
            }
          } );        
      }
    }
  },
  computed: {
    ...mapGetters(["userTokenData",'loggedin', 'loadingdata']),
    ...mapState({
      errors: state => state.auth.autherrors,
      curLanguage: state => state.translations.curLanguage
    })
  }
};
</script>
